import { Space, Pagination, Button, Input, Col, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useState, useEffect, useRef } from "react";
import { Card } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { get } from "../../services";
// scroll Top
const useScroll = () => {
  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();
  return [executeScroll, myRef];
};
const { Meta } = Card;
const Usertable = () => {
  /* Navigation and Location to use for page switching and getting specific page url */
  const navigate = useNavigate();
  const location = useLocation();
  /* Query Params to get from URL */
  const queryParams = new URLSearchParams(location.search);
  const pageParams = queryParams.get("page");
  const nameParams = queryParams.get("name");
  const addressParams = queryParams.get("address");
  const phoneParams = queryParams.get("phone");
  /* Local States to save data */
  const [searchByParams, setSearchByParams] = useState("");
  const [userData, setUserData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [executeScroll, myRef] = useScroll();
  const [selectedFilters, setSelectedFilters] = useState({});
  const searchInput = useRef(null);

  // method for API call
  const getUserHandler = (page, searchByParams) => {
    setLoader(true);
    // queryString to check any filter option is selected or not
    let payload = "";
    if (searchByParams && searchByParams?.name) {
      payload = `&name=${searchByParams?.name}`;
    }
    if (searchByParams && searchByParams?.address) {
      payload = payload + `&address=${searchByParams?.address}`;
    }
    if (searchByParams && searchByParams?.phone) {
      payload = payload + `&phone=${searchByParams?.phone}`;
    }
    //axios call
    get(`/hostaway/getListings?limit=20&page=${page}`)
      .then((response) => {
        setUserData(response?.data);
        console.log(response);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  console.log("username", userData);
  // handler to search data from using using specific key (name,address)
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    // if not empty and same object is entered
    let searched = searchByParams
      ? {
          ...searchByParams,
          [dataIndex]: dataIndex !== "gender" ? selectedKeys[0] : selectedKeys,
        }
      : {
          [dataIndex]: dataIndex !== "gender" ? selectedKeys[0] : selectedKeys,
        };
    setSearchByParams(searched);
    navigate(
      `/properties?page=${1}${
        searched?.address ? `&address=${searched?.address}` : ""
      }${searched?.name ? `&name=${searched?.name}` : ""}`
    );
    // API CALL
    getUserHandler(1, searched);
    setCurrentPage(1);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchByParams("");
    getUserHandler(1, {});
    setCurrentPage(1);
    setSelectedFilters({});
    navigate(`/properties?page=${1}`);
  };

  // handler for name , address
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedFilters[dataIndex]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
            setSelectedFilters({ ...selectedFilters, address: e.target.value });
          }}
          onPressEnter={() => {
            handleSearch(selectedKeys, confirm, dataIndex);
            close();
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => {
              handleSearch(selectedKeys, confirm, dataIndex);
              close();
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              setSelectedKeys("");
              close();
            }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  //  API for user
  useEffect(() => {
    let paramsPayload = {};
    if (addressParams || nameParams || phoneParams) {
      paramsPayload = {
        address: addressParams,
        name: nameParams,
        phone: phoneParams,
      };
    }
    setSearchByParams(paramsPayload);
    setSelectedFilters(paramsPayload);
    getUserHandler(pageParams ? pageParams : 1, paramsPayload);
    setCurrentPage(pageParams ? parseInt(pageParams) : 1);
    // eslint-disable-next-line
  }, []);

  // const columns = [
  //   {
  //     title: "listing Id",
  //     dataIndex: "listingId",
  //     key: "listingId",
  //     render: (data) => <Space>{data}</Space>,
  //   },
  //   {
  //     title: "Name",
  //     dataIndex: "",
  //     key: "profile",
  //     ...getColumnSearchProps("name"),
  //     render: (data) => (
  //       <div>
  //         <Image
  //           width={50}
  //           height={50}
  //           style={{ borderRadius: "50%" }}
  //           src="error"
  //           fallback={
  //             data?.listingImages !== ""
  //               ? data?.listingImages[0].url
  //               : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
  //           }
  //         />
  //         <Space size="middle" style={{ padding: "0px 10px" }}>
  //           {data?.name}
  //         </Space>
  //       </div>
  //     ),
  //   },
  //   {
  //     title: "Address",
  //     dataIndex: "address",
  //     key: "address",
  //     render: (data) => (
  //       <Space size="middle">
  //         <Space size="middle">{data || "-"}</Space>
  //       </Space>
  //     ),
  //     ...getColumnSearchProps("address"),
  //   },
  //   {
  //     title: "Beds",
  //     dataIndex: "bedsNumber",
  //     key: "bedsNumber",
  //     // ...getColumnSearchProps("phone"),
  //     render: (data) => (
  //       <Space size="middle">{data === null ? "-" : data}</Space>
  //     ),
  //   },
  //   {
  //     title: "Action",
  //     key: "action",
  //     render: (data) => (
  //       <Space>
  //         <Link to={`/properties/${data?.id}`}>View Details</Link>
  //         <Link to={`/create-task/${data?._id}`}>Assign Task</Link>
  //       </Space>
  //     ),
  //   },
  // ];

  return (
    <div ref={myRef}>
      <div className="header" style={{ paddingBottom: "15px" }}>
        <h3>All Properties</h3>
        <div>
        <Input placeholder="Search By Name" />
        </div>
      </div>
      {/* table */}
      <div>
        {/* <Table
          columns={columns}
          dataSource={userData?.listings}
          loading={loader}
          pagination={false}
          scroll={{ x: 1023 }}
        /> */}
        <Row gutter={24} scroll={{ x: 1023 }}>
          {userData?.listings?.map((item, index) => (
            <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={index}>
              <Card
                style={{
                  marginBottom: "20px",
                }}
                cover={
                  <img
                    src={
                      item?.listingImages && item?.listingImages.length > 0
                        ? item?.listingImages[0].url
                        : ""
                    }
                    alt="Listing Image"
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  />
                }
                actions={[
                  <Link
                    to={`/properties/${item?.id}`}
                    className="assign-text"
                  >
                   View Details
                  </Link>,
                  <Link
                    to={`/create-task/${item?._id}`}
                    className="assign-text"
                  >
                    Assign Task
                  </Link>,
                ]}
              >
                <Meta   />
                <h3 className="turncate-main  ">{item?.name}</h3>
                <p className="turncate">{item?.description}</p>
              </Card>
            </Col>
          ))}
        </Row>
        {/* Pagination */}
        <Pagination
          defaultPageSize={currentPage}
          showSizeChanger={false}
          current={currentPage}
          total={userData?.totalPages}
          onChange={(e) => {
            setCurrentPage(e);
            getUserHandler(e, searchByParams);
            executeScroll();
            navigate(
              `/properties?page=${e}${
                searchByParams?.phone ? `&phone=${searchByParams?.phone}` : ""
              }${
                searchByParams?.address
                  ? `&address=${searchByParams?.address}`
                  : ""
              }${searchByParams?.name ? `&phone=${searchByParams?.name}` : ""}`
            );
          }}
          className="pagination"
        />
      </div>
    </div>
  );
};
export default Usertable;
